import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { InvoiceUpdateInput, InvoiceUpdatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = InvoiceUpdateInput;
type TData = InvoiceUpdatePayload;

export const useInvoiceUpdate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation invoiceUpdate($input: InvoiceUpdateInput!) {
      invoiceUpdate(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
